import * as React from "react";
import { ModalContext } from "../managers/ModalManager";

function useModal() {
  const { hideModal, showModal } = React.useContext(ModalContext);

  return {
    hideModal,
    showModal
  };
}

export default useModal;
